// SubscriptionHistory.js
import React from 'react';
import { Box, Typography, List, ListItem, ListItemText, Divider, CircularProgress, Alert } from '@mui/material';

// Mock data or fetch logic will go here
const mockHistory = [
    { id: 'hist_1', date: '2024-08-01T10:00:00Z', event_type: 'Subscribed', plan_name: 'Premium Plan', details: 'Started new subscription.' },
    { id: 'hist_2', date: '2024-06-01T09:55:00Z', event_type: 'Plan Change', plan_name: 'Basic Plan', details: 'Upgraded from Freemium.' },
    { id: 'hist_3', date: '2024-05-15T00:00:00Z', event_type: 'Subscribed', plan_name: 'Freemium Plan', details: 'Account created.' },
];

const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
        return new Date(dateString).toLocaleString('en-US', {
            year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit'
        });
    } catch (e) {
        console.warn("Date/Time formatting failed:", e);
        return dateString; // Fallback
    }
 };

const SubscriptionHistory = () => {
    // --- STATE ---
    const [history, setHistory] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(null);

    // --- MOCK FETCH ---
    // Replace with actual API call using useEffect
    React.useEffect(() => {
        const fetchHistory = async () => {
            setLoading(true);
            setError(null);
            try {
                // TODO: Replace with:
                // 
                // const response = await axiosInstance.get(`/subscriptions/history`);
                // setHistory(response.data); // Assuming response.data is an array of history events

                // Using mock data for now
                await new Promise(resolve => setTimeout(resolve, 800)); // Simulate network delay
                setHistory(mockHistory);

            } catch (err) {
                console.error("Error fetching subscription history:", err);
                setError(err.response?.data?.message || err.message || "Failed to load subscription history.");
            } finally {
                setLoading(false);
            }
        };

        fetchHistory();
    }, []);

    // --- RENDER LOGIC ---
    if (loading) {
        return <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}><CircularProgress /></Box>;
    }

    if (error) {
        return <Alert severity="error">{error}</Alert>;
    }

    return (
        <Box>
            <Typography variant="h5" gutterBottom>
                Subscription History
            </Typography>
            {history.length === 0 ? (
                <Typography>No subscription history found.</Typography>
            ) : (
                <List sx={{ width: '100%', bgcolor: 'background.paper', border: '1px solid #eee', borderRadius: '4px' }}>
                    {history.map((event, index) => (
                        <React.Fragment key={event.id}>
                            <ListItem alignItems="flex-start">
                                <ListItemText
                                    primary={`${event.event_type} - ${event.plan_name}`}
                                    secondary={
                                        <React.Fragment>
                                            <Typography
                                                sx={{ display: 'block' }}
                                                component="span"
                                                variant="body2"
                                                color="text.primary"
                                            >
                                                {formatDate(event.date)}
                                            </Typography>
                                            {event.details}
                                        </React.Fragment>
                                    }
                                />
                            </ListItem>
                            {index < history.length - 1 && <Divider variant="inset" component="li" />}
                        </React.Fragment>
                    ))}
                </List>
            )}
        </Box>
    );
};

export default SubscriptionHistory;